import {
  POWERBI_SECURITY_DATA,
  POWERBI_SECURITY_GET_DATA,
  POWERBI_SECURITY_ADD_DATA,
  POWERBI_SECURITY_UPDATE_DATA,
  POWERBI_SECURITY_DELETE_DATA,
  POWERBI_ROLES_DATA,
  POWERBI_SECURITY_GET_REPORT_PAGES,
} from "./Constants";

const initialState = {
  loading: false,
  error: null,
  securityList: [],
  security: null,
  addSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,
  roles: [],
  rolesLoading: false,
  rolesError: null,
  reportPages: [],
  reportPagesLoading: false,
  reportPagesError: null,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    // ==================== Load Security List ====================
    case POWERBI_SECURITY_DATA.POWERBI_SECURITY_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POWERBI_SECURITY_DATA.POWERBI_SECURITY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        securityList: action.securityList,
        error: null,
      };
    case POWERBI_SECURITY_DATA.POWERBI_SECURITY_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        securityList: [],
      };

    // ==================== Get Security Details ====================
    case POWERBI_SECURITY_GET_DATA.POWERBI_SECURITY_GET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        security: null,
        error: null,
      };
    case POWERBI_SECURITY_GET_DATA.POWERBI_SECURITY_GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        security: action.security,
        error: null,
      };
    case POWERBI_SECURITY_GET_DATA.POWERBI_SECURITY_GET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        security: null,
        error: action.error,
      };

    // ==================== Add Security ====================
    case POWERBI_SECURITY_ADD_DATA.POWERBI_SECURITY_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        addSuccess: false,
        error: null,
      };
    case POWERBI_SECURITY_ADD_DATA.POWERBI_SECURITY_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        addSuccess: true,
        error: null,
      };
    case POWERBI_SECURITY_ADD_DATA.POWERBI_SECURITY_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        addSuccess: false,
        error: action.error,
      };

    // ==================== Update Security ====================
    case POWERBI_SECURITY_UPDATE_DATA.POWERBI_SECURITY_UPDATE_DATA_LOAD:
      return {
        ...state,
        loading: true,
        updateSuccess: false,
        error: null,
      };
    case POWERBI_SECURITY_UPDATE_DATA.POWERBI_SECURITY_UPDATE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        updateSuccess: true,
        error: null,
      };
    case POWERBI_SECURITY_UPDATE_DATA.POWERBI_SECURITY_UPDATE_DATA_FAIL:
      return {
        ...state,
        loading: false,
        updateSuccess: false,
        error: action.error,
      };

    // ==================== Delete Security ====================
    case POWERBI_SECURITY_DELETE_DATA.POWERBI_SECURITY_DELETE_DATA_LOAD:
      return {
        ...state,
        loading: true,
        deleteSuccess: false,
        error: null,
      };
    case POWERBI_SECURITY_DELETE_DATA.POWERBI_SECURITY_DELETE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: true,
        error: null,
      };
    case POWERBI_SECURITY_DELETE_DATA.POWERBI_SECURITY_DELETE_DATA_FAIL:
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
        error: action.error,
      };

    // ==================== Load PowerBI Roles ====================
    case POWERBI_ROLES_DATA.POWERBI_ROLES_DATA_LOAD:
      return {
        ...state,
        rolesLoading: true,
        rolesError: null,
      };
    case POWERBI_ROLES_DATA.POWERBI_ROLES_DATA_SUCCESS:
      return {
        ...state,
        rolesLoading: false,
        roles: action.roles,
        rolesError: null,
      };
    case POWERBI_ROLES_DATA.POWERBI_ROLES_DATA_FAIL:
      return {
        ...state,
        rolesLoading: false,
        roles: [],
        rolesError: action.error,
      };

    // ==================== Get Report Pages ====================
    case POWERBI_SECURITY_GET_REPORT_PAGES.POWERBI_SECURITY_GET_REPORT_PAGES_LOAD:
      return {
        ...state,
        reportPagesLoading: true,
        reportPagesError: null,
      };
    case POWERBI_SECURITY_GET_REPORT_PAGES.POWERBI_SECURITY_GET_REPORT_PAGES_SUCCESS:
      return {
        ...state,
        reportPagesLoading: false,
        reportPages: action.pages,
        reportPagesError: null,
      };
    case POWERBI_SECURITY_GET_REPORT_PAGES.POWERBI_SECURITY_GET_REPORT_PAGES_FAIL:
      return {
        ...state,
        reportPagesLoading: false,
        reportPages: [],
        reportPagesError: action.error,
      };

    default:
      return {
        ...state,
      };
  }
};

export default Reducer;
